'use strict';

var ReviewInputDataChartTransformerFactory = function ReviewInputDataChartTransformerFactory(DataTransformer) {
  function ReviewInputDataChartTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = 'seasonality-untruncated-md-mode';
    this.targetType = 'seasonality-review-input-data-chart';
    this.priority = 1;
  }
  ReviewInputDataChartTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  ReviewInputDataChartTransformerFactory.constructor = ReviewInputDataChartTransformerFactory;
  ReviewInputDataChartTransformerFactory.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  ReviewInputDataChartTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  ReviewInputDataChartTransformerFactory.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType + '-' + metrics.join('-');
  };
  ReviewInputDataChartTransformerFactory.prototype.transform = function (data) {
    return data.domain;
  };
  return ReviewInputDataChartTransformerFactory;
};
ReviewInputDataChartTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = ReviewInputDataChartTransformerFactory;